import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, Fragment as _Fragment, renderList as _renderList, createSlots as _createSlots } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "panel info"
}
const _hoisted_2 = { class: "grid-3 gap-sm" }
const _hoisted_3 = { class: "panel span-2" }
const _hoisted_4 = { class: "dl-with-margin" }
const _hoisted_5 = { class: "d-block" }
const _hoisted_6 = { class: "d-block" }
const _hoisted_7 = { class: "list-unstyled" }
const _hoisted_8 = ["href"]
const _hoisted_9 = { class: "panel" }
const _hoisted_10 = {
  key: 0,
  class: "panel"
}
const _hoisted_11 = { class: "list-unstyled" }

import { computed, onBeforeMount, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useGettext } from '@jshmrtn/vue3-gettext';
import { Flash } from '@/core/Flash';
import { handleLoadError } from '@/core/common';
import { dateTime } from '@/core/date';
import auth from '@/core/Auth';
import PageLayout from '@/core/components/PageLayout.vue';
import AppButton from '@/core/components/form/AppButton.vue';
import FaIcon from '@/core/components/FaIcon.vue';
import TicketViewComments from '@/modules/ticket/components/TicketViewComments.vue';
import TicketViewDetailsForm from '@/modules/ticket/components/TicketViewDetailsForm.vue';
import TicketViewDoneModal from '@/modules/ticket/components/TicketViewDoneModal.vue';
import TicketViewMergeModal from '@/modules/ticket/components/TicketViewMergeModal.vue';
import { Ticket, TicketAttachment, useTicket } from '@/modules/ticket/Ticket';

type TicketViewModal = 'DONE' | 'MERGE';


export default /*@__PURE__*/_defineComponent({
  __name: 'TicketView',
  setup(__props) {

const { $gettext, interpolate } = useGettext();
const route = useRoute();
const router = useRouter();
const resource = useTicket();
const ticket = ref<Ticket | null>(null);
const attachments = ref<TicketAttachment[]>([]);
const canMerge = computed<boolean>(() => (
	!!ticket.value
	&& ticket.value.state !== 'DONE'
	&& ticket.value.merged.length === 0
	&& !ticket.value.merged_to
	&& auth.can('TICKET_ASSIGN')
));
const openedModal = ref<TicketViewModal | null>(null);

const load = async () => {
	if (!route.params.id) {
		return;
	}

	try {
		ticket.value = await resource.get(route.params.id as string);
	} catch (e) {
		handleLoadError(e as Error, 'ticket.index');
		return;
	}

	attachments.value = await resource.getAttachments(ticket.value.id);
};

watch(route, () => {
	load();
});
onBeforeMount(load);

const pageTitle = computed(() => {
	if (!ticket.value) {
		return $gettext('Ärende');
	}

	return interpolate(
		$gettext('Ärende #%{ id }'),
		{id: ticket.value.id},
	);
});

const reporterName = computed(() => {
	if (!ticket.value?.reporter_name) {
		return $gettext('Anonym användare');
	}

	return ticket.value.reporter_name;
});

const cancel = () => {
	router.push({ name: 'ticket.index' });
};

const openModal = (type: TicketViewModal) => {
	openedModal.value = type;
};

const closeModal = () => {
	openedModal.value = null;
};

const sendDoneState = async () => {
	if (!ticket.value) {
		return;
	}

	await resource.putState(ticket.value.id, 'DONE');

	Flash.success($gettext('Ärendet har klarmarkerats!'));
	cancel();
};

const saveMerge = async (destination: number) => {
	if (!ticket.value) {
		return;
	}

	try {
		const destinationTicket = await resource.putMerge(ticket.value.id, destination);

		Flash.success(interpolate(
			$gettext('Ärendet har sammanfogats med %{id}'),
			{id: destinationTicket.id},
		));
		closeModal();

		router.push({
			name: 'ticket.view',
			params: {
				id: destinationTicket.id,
			},
		})
	} catch (err) {
		Flash.fromError(err as Error, 20000);
	}
};

const ticketUpdated = (newTicket: Ticket) => {
	const oldTicket = ticket.value as Ticket;

	newTicket.reporter_name = oldTicket.reporter_name;
	newTicket.what = oldTicket.what;
	newTicket.where = oldTicket.where;
	newTicket.description = oldTicket.description;

	ticket.value = newTicket;
};

return (_ctx: any,_cache: any) => {
  const _component_translate = _resolveComponent("translate")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createBlock(PageLayout, { "page-title": pageTitle.value }, _createSlots({
    "header-actions": _withCtx(() => [
      (ticket.value && ticket.value.state !== 'DONE')
        ? (_openBlock(), _createBlock(AppButton, {
            key: 0,
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (openModal('DONE')), ["prevent"]))
          }, {
            default: _withCtx(() => [
              _createVNode(FaIcon, { icon: "check" }),
              _createVNode(_component_translate, null, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createTextVNode("Klarmarkera", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (canMerge.value)
        ? (_openBlock(), _createBlock(AppButton, {
            key: 1,
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (openModal('MERGE')), ["prevent"]))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_translate, null, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createTextVNode("Sammanfoga", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(AppButton, {
        onClick: _withModifiers(cancel, ["prevent"])
      }, {
        default: _withCtx(() => [
          _createVNode(_component_translate, null, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
              _createTextVNode("Avbryt", -1)
            ]))]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 2
  }, [
    (ticket.value !== null)
      ? {
          name: "content",
          fn: _withCtx(() => [
            (ticket.value.merged_to)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createElementVNode("p", null, [
                    _createVNode(FaIcon, { icon: "info-circle" }),
                    _createVNode(_component_translate, null, {
                      default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                        _createTextVNode("Det här ärendet har sammanfogats med", -1)
                      ]))]),
                      _: 1
                    }),
                    _createVNode(_component_RouterLink, {
                      to: {
						name: 'ticket.view',
						params: {
							id: ticket.value.merged_to,
						},
					}
                    }, {
                      default: _withCtx(() => [
                        _withDirectives((_openBlock(), _createElementBlock("span", null, [...(_cache[6] || (_cache[6] = [
                          _createTextVNode(" Ärende #%{ id } ", -1)
                        ]))])), [
                          [_directive_translate, {id: ticket.value.merged_to}]
                        ])
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("h2", null, _toDisplayString(ticket.value.what), 1),
                _createElementVNode("dl", _hoisted_4, [
                  _withDirectives((_openBlock(), _createElementBlock("dt", null, [...(_cache[7] || (_cache[7] = [
                    _createTextVNode("Namn", -1)
                  ]))])), [
                    [_directive_translate]
                  ]),
                  _createElementVNode("dd", null, _toDisplayString(reporterName.value), 1),
                  _withDirectives((_openBlock(), _createElementBlock("dt", null, [...(_cache[8] || (_cache[8] = [
                    _createTextVNode("Skapad", -1)
                  ]))])), [
                    [_directive_translate]
                  ]),
                  _createElementVNode("dd", null, _toDisplayString(_unref(dateTime)(ticket.value.created_time)), 1),
                  (ticket.value.category)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _withDirectives((_openBlock(), _createElementBlock("dt", null, [...(_cache[9] || (_cache[9] = [
                          _createTextVNode("Kategori", -1)
                        ]))])), [
                          [_directive_translate]
                        ]),
                        _createElementVNode("dd", null, _toDisplayString(ticket.value.category.name), 1)
                      ], 64))
                    : _createCommentVNode("", true),
                  _withDirectives((_openBlock(), _createElementBlock("dt", null, [...(_cache[10] || (_cache[10] = [
                    _createTextVNode("När inträffade detta?", -1)
                  ]))])), [
                    [_directive_translate]
                  ]),
                  _createElementVNode("dd", null, _toDisplayString(ticket.value.when), 1),
                  _withDirectives((_openBlock(), _createElementBlock("dt", null, [...(_cache[11] || (_cache[11] = [
                    _createTextVNode("Var hände detta?", -1)
                  ]))])), [
                    [_directive_translate]
                  ]),
                  _createElementVNode("dd", _hoisted_5, _toDisplayString(ticket.value.where), 1),
                  _withDirectives((_openBlock(), _createElementBlock("dt", null, [...(_cache[12] || (_cache[12] = [
                    _createTextVNode("Beskriv vad som hände", -1)
                  ]))])), [
                    [_directive_translate]
                  ]),
                  _createElementVNode("dd", _hoisted_6, _toDisplayString(ticket.value.description), 1)
                ]),
                (attachments.value.length)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _withDirectives((_openBlock(), _createElementBlock("h3", null, [...(_cache[13] || (_cache[13] = [
                        _createTextVNode("Bilagor", -1)
                      ]))])), [
                        [_directive_translate]
                      ]),
                      _createElementVNode("ul", _hoisted_7, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(attachments.value, (attachment) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: attachment.id
                          }, [
                            _createElementVNode("a", {
                              href: `/api/ticket/${ticket.value.id}/attachment/${attachment.id}`
                            }, [
                              _createVNode(FaIcon, { icon: "paperclip" }),
                              _createTextVNode(" " + _toDisplayString(attachment.file_name), 1)
                            ], 8, _hoisted_8)
                          ]))
                        }), 128))
                      ])
                    ], 64))
                  : _createCommentVNode("", true),
                _createVNode(TicketViewComments, { ticket: ticket.value }, null, 8, ["ticket"])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_9, [
                  _withDirectives((_openBlock(), _createElementBlock("h2", null, [...(_cache[14] || (_cache[14] = [
                    _createTextVNode("Egenskaper", -1)
                  ]))])), [
                    [_directive_translate]
                  ]),
                  _createVNode(TicketViewDetailsForm, {
                    ticket: ticket.value,
                    onSaved: ticketUpdated
                  }, null, 8, ["ticket"])
                ]),
                (ticket.value.merged.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _withDirectives((_openBlock(), _createElementBlock("h2", null, [...(_cache[15] || (_cache[15] = [
                        _createTextVNode("Sammanslagna ärenden", -1)
                      ]))])), [
                        [_directive_translate]
                      ]),
                      _createElementVNode("ul", _hoisted_11, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ticket.value.merged, (merged) => {
                          return (_openBlock(), _createElementBlock("li", { key: merged }, [
                            _withDirectives((_openBlock(), _createBlock(_component_RouterLink, {
                              to: {
										name: 'ticket.view',
										params: {
											id: merged,
										},
									}
                            }, {
                              default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                                _createTextVNode(" Ärende #%{ id } ", -1)
                              ]))]),
                              _: 1
                            }, 8, ["to"])), [
                              [_directive_translate, {id: merged}]
                            ])
                          ]))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            (openedModal.value === 'DONE')
              ? (_openBlock(), _createBlock(TicketViewDoneModal, {
                  key: 1,
                  ticket: ticket.value,
                  onRequestDone: sendDoneState,
                  onCancel: closeModal
                }, null, 8, ["ticket"]))
              : _createCommentVNode("", true),
            (openedModal.value === 'MERGE')
              ? (_openBlock(), _createBlock(TicketViewMergeModal, {
                  key: 2,
                  ticket: ticket.value,
                  onRequestMerge: saveMerge,
                  onCancel: closeModal
                }, null, 8, ["ticket"]))
              : _createCommentVNode("", true)
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["page-title"]))
}
}

})